import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import LoadingComponent from '../loading';

import Payslipemp from './Payslipemp';
import ProfileEmp from './ProfileEmp';
import LeavesEmp from './LeavesEmp';
import TeamLeaves from './Leaves/TeamLeaves';
import TeamAttendance from './TeamAttendance';
import Emphome from './Emphome';
import AttendanceEmp from './AttendanceEmp';
import DeclarationsEmp from './Form16/DeclarationsEmp';
import Form16Emp from './Form16/Form16Emp';
import Form16EmpDetail from './Form16/Form16EmpDetail';
import RectifyForm from './Form16/RectifyForm';
import TaxCalculatorEmp from './TaxCalculator/TaxCalculatorEmp';

function Emproutes() {
  return (
    <Suspense fallback={<LoadingComponent loading />}>
      <Routes>
        <Route path='/payslip' element={<Payslipemp />} />
        <Route path='/profile' element={<ProfileEmp />} />
        <Route path='/leaves' element={<LeavesEmp />} />
        <Route path='/team-leaves' element={<TeamLeaves />} />
        <Route path='/team-attendance' element={<TeamAttendance />} />
        <Route path='/attendance' element={<AttendanceEmp />} />
        <Route path='/home' element={<Emphome />} />

        {/* Form 16 employee routes */}
        <Route path='/declarations' element={<DeclarationsEmp />} />
        <Route path='/form16' element={<Form16Emp />} />
        <Route path='/form16/:id' element={<Form16EmpDetail />} />
        <Route path='/form16/rectify' element={<RectifyForm />} />

        {/* Tax Calculator */}
        <Route path='/tax-calculator' element={<TaxCalculatorEmp />} />

        <Route path="*" element={<Navigate to={'/home'} />} />
      </Routes>
    </Suspense>
  );
}

export default Emproutes;
